import React from 'react';
export function Footer() {
  return <footer className="bg-blue-950 border-t-4 border-orange-500 py-10 px-4 text-center" data-id="element-117" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-white/70" data-id="element-118" data-mp="3ggtymjf7hl5r">
        © Dog Grooming Instructor Ready 2026 — All rights reserved.
      </p>
    </footer>;
}